import React, { useState } from 'react';
import VariationTranslateModal from './VariationTranslateModal';
import { Variation } from 'packages/pages/design/VariationsContext/types';

const useVariationTranslateModal = ({ getVariationsAndSave, variationsTotal }) => {
    const [variation, setVariation] = useState<Variation | null>(null);

    const onClose = () => {
        setVariation(null);
    };

    const renderVariationTranslateModal = () => (
        <VariationTranslateModal
            // @ts-ignore
            variation={variation}
            onClose={onClose}
            getVariationsAndSave={getVariationsAndSave}
            variationsTotal={variationsTotal}
        />
    );

    return {
        setVariationTranslateModal: setVariation,
        renderVariationTranslateModal,
    };
};

export default useVariationTranslateModal;
